// Manejo de precios escalonados para tours compartidos - POR IDIOMA
document.addEventListener('turbolinks:load', function() {
  // Verificar si estamos en la página de formulario de tours
  if (document.getElementById('tour_tour_type_id')) {
    const tourTypeSelect = document.getElementById('tour_tour_type_id');
    const tieredPricesSection = document.getElementById('tiered_prices_section');
    
    // Contenedores y campos para cada idioma
    const containers = {
      en: document.getElementById('tiered_prices_container_en'),
      es: document.getElementById('tiered_prices_container_es')
    };
    const addButtons = {
      en: document.getElementById('add_price_tier_en'),
      es: document.getElementById('add_price_tier_es')
    };
    const jsonFields = {
      en: document.getElementById('tiered_prices_json_en'),
      es: document.getElementById('tiered_prices_json_es')
    };
    // Legacy field for backwards compatibility
    const legacyJsonField = document.getElementById('tiered_prices_json');
    
    // Función para actualizar la visibilidad de la sección de precios escalonados
    function updateTieredPricesVisibility() {
      // Tour Type ID 2 corresponde a "Shared Tours"
      if (tourTypeSelect.value === '2') {
        tieredPricesSection.style.display = 'block';
      } else {
        tieredPricesSection.style.display = 'none';
        // Si se cambia a un tipo de tour que no es compartido, limpiar todo
        ['en', 'es'].forEach(lang => {
          if (jsonFields[lang]) jsonFields[lang].value = '[]';
          const rows = document.querySelectorAll(`.price-tier-row-${lang}`);
          rows.forEach(row => row.remove());
        });
        if (legacyJsonField) legacyJsonField.value = '[]';
      }
    }
    
    // Verificar el estado inicial
    updateTieredPricesVisibility();
    
    // Escuchar cambios en el tipo de tour
    tourTypeSelect.addEventListener('change', updateTieredPricesVisibility);
    
    // Cargar precios existentes para cada idioma
    ['en', 'es'].forEach(lang => {
      let tieredPrices = [];
      const jsonField = jsonFields[lang];
      
      console.log(`[TieredPrices] Cargando precios para idioma: ${lang}`);
      console.log(`[TieredPrices] Campo encontrado:`, jsonField);
      console.log(`[TieredPrices] Valor inicial del campo ${lang}:`, jsonField ? jsonField.value : 'NO ENCONTRADO');
      
      if (jsonField) {
        try {
          if (jsonField.value && jsonField.value !== '[]') {
            tieredPrices = JSON.parse(jsonField.value);
            console.log(`[TieredPrices] Precios parseados para ${lang}:`, tieredPrices);
          }
        } catch (e) {
          console.error(`Error al parsear los precios escalonados para ${lang}:`, e);
          tieredPrices = [];
        }
        
        // Renderizar precios existentes
        if (tieredPrices.length > 0) {
          console.log(`[TieredPrices] Renderizando ${tieredPrices.length} niveles de precio para ${lang}`);
          tieredPrices.forEach(tier => {
            addPriceTierRow(lang, tier.participants, tier.price, true); // skipUpdate=true para carga inicial
          });
        }
      }
    });
    
    // Función para agregar una nueva fila de precio escalonado para un idioma específico
    // skipUpdate=true cuando se cargan datos existentes para evitar sobrescribir el campo JSON
    function addPriceTierRow(lang, participants = '', price = '', skipUpdate = false) {
      const container = containers[lang];
      if (!container) {
        console.error(`[TieredPrices] Contenedor no encontrado para idioma: ${lang}`);
        return;
      }
      
      const rowDiv = document.createElement('div');
      rowDiv.className = `price-tier-row-${lang} row mb-2`;
      rowDiv.dataset.lang = lang; // Agregar data attribute para identificar el idioma
      rowDiv.innerHTML = `
        <div class="col-5">
          <div class="form-floating">
            <input type="number" class="form-control tier-participants" data-lang="${lang}" value="${participants}" min="1" placeholder=" ">
            <label>${(document.querySelector('html').getAttribute('lang') || 'en') === 'en' ? 'Participants' : 'Participantes'}</label>
          </div>
        </div>
        <div class="col-5">
          <div class="form-floating">
            <input type="number" class="form-control tier-price" data-lang="${lang}" value="${price}" min="0" step="0.01" placeholder=" ">
            <label>${(document.querySelector('html').getAttribute('lang') || 'en') === 'en' ? 'Price/Person' : 'Precio/Persona'}</label>
          </div>
        </div>
        <div class="col-2 d-flex align-items-center">
          <button type="button" class="btn btn-danger btn-sm remove-tier" data-lang="${lang}">
            <i class="fas fa-trash"></i>
          </button>
        </div>
      `;
      
      // Insertar antes del botón de agregar
      const buttonContainer = container.querySelector('.mb-3');
      container.insertBefore(rowDiv, buttonContainer);
      
      // Agregar evento para eliminar esta fila
      rowDiv.querySelector('.remove-tier').addEventListener('click', function() {
        rowDiv.remove();
        updateTieredPricesJsonForLang(lang);
      });
      
      // Agregar eventos para actualizar el JSON cuando cambian los valores
      rowDiv.querySelector('.tier-participants').addEventListener('change', () => updateTieredPricesJsonForLang(lang));
      rowDiv.querySelector('.tier-price').addEventListener('change', () => updateTieredPricesJsonForLang(lang));
      
      // Solo actualizar JSON si no es carga inicial
      if (!skipUpdate) {
        updateTieredPricesJsonForLang(lang);
      }
    }
    
    // Función para actualizar el campo JSON oculto para un idioma específico
    function updateTieredPricesJsonForLang(lang) {
      // Buscar filas SOLO dentro del contenedor correcto para evitar mezclas
      const container = containers[lang];
      if (!container) {
        console.error(`[TieredPrices] updateTieredPricesJsonForLang: Contenedor no encontrado para ${lang}`);
        return;
      }
      
      const rows = container.querySelectorAll(`.price-tier-row-${lang}`);
      console.log(`[TieredPrices] updateTieredPricesJsonForLang(${lang}): Encontradas ${rows.length} filas en contenedor`);
      
      const prices = [];
      
      rows.forEach((row, index) => {
        const participantsInput = row.querySelector('.tier-participants');
        const priceInput = row.querySelector('.tier-price');
        
        if (!participantsInput || !priceInput) {
          console.error(`[TieredPrices] Fila ${index} de ${lang}: inputs no encontrados`);
          return;
        }
        
        const participants = parseInt(participantsInput.value) || 0;
        const price = parseFloat(priceInput.value) || 0;
        console.log(`[TieredPrices] Fila ${index} de ${lang}: participants=${participants}, price=${price}`);
        
        // Validación visual para el usuario
        if (participants <= 0) {
          participantsInput.classList.add('is-invalid');
        } else {
          participantsInput.classList.remove('is-invalid');
        }
        
        if (price <= 0) {
          priceInput.classList.add('is-invalid');
        } else {
          priceInput.classList.remove('is-invalid');
        }
        
        if (participants > 0) {
          prices.push({
            participants: participants,
            price: price
          });
        }
      });
      
      // Ordenar por número de participantes
      prices.sort((a, b) => a.participants - b.participants);
      
      // Actualizar el campo oculto para este idioma
      if (jsonFields[lang]) {
        jsonFields[lang].value = JSON.stringify(prices);
        console.log(`[TieredPrices] Actualizado campo ${lang} con:`, jsonFields[lang].value);
      }
    }
    
    // Eventos para agregar nuevos niveles de precio
    ['en', 'es'].forEach(lang => {
      const addButton = addButtons[lang];
      if (addButton) {
        addButton.addEventListener('click', function() {
          addPriceTierRow(lang);
        });
      }
    });
    
    // Validar el formulario antes de enviar
    const tourForm = document.querySelector('form');
    if (tourForm) {
      tourForm.addEventListener('submit', function(e) {
        console.log('[TieredPrices] Enviando formulario...');
        
        // Asegurarnos que tiered_prices siempre tenga un valor válido
        if (tourTypeSelect.value !== '2') {
          // Para los tours no compartidos, siempre enviar arrays vacíos
          ['en', 'es'].forEach(lang => {
            if (jsonFields[lang]) jsonFields[lang].value = '[]';
          });
          if (legacyJsonField) legacyJsonField.value = '[]';
        } else {
          // Para tours compartidos, actualizar los campos JSON con los valores actuales de las filas
          console.log('[TieredPrices] ===== ANTES DE ACTUALIZAR =====');
          console.log('[TieredPrices] Campo EN actual:', jsonFields.en ? jsonFields.en.value : 'NO EXISTE');
          console.log('[TieredPrices] Campo ES actual:', jsonFields.es ? jsonFields.es.value : 'NO EXISTE');
          
          ['en', 'es'].forEach(lang => {
            updateTieredPricesJsonForLang(lang);
          });
          
          console.log('[TieredPrices] ===== DESPUÉS DE ACTUALIZAR =====');
          console.log('[TieredPrices] Campo EN final:', jsonFields.en ? jsonFields.en.value : 'NO EXISTE');
          console.log('[TieredPrices] Campo ES final:', jsonFields.es ? jsonFields.es.value : 'NO EXISTE');
          
          if (legacyJsonField) legacyJsonField.value = '[]';
        }
      });
    }
  }
});
